import Vue from 'vue';
// eslint-disable-next-line
import babelPolyfill from 'babel-polyfill';
import router from './router';
import store from './store';

import App from './App.vue';
import vuetify from './plugins/vuetify';

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app');
